package org.hs_soft.runmynesto.domain.model.general

enum class WindowSizeModeEnum
{
    PHONE,
    TABLET,
    Desktop,
}